import { useEffect, useState } from 'react';
import { isNull, isUndefined } from 'underscore';

import { Address, Route } from '@/config/types/Routes';
import { urls } from '@/config/urls';

const { server } = urls;

export type AddressesByKeyType = {
    [key: string]: Address
  }  

export type EndAddressesType = {
    endAddresses?: AddressesByKeyType
};
  

export const useEndAddresses = (routes: {[key: string]: Route}): AddressesByKeyType => {
  const [endAddresses, setEndAddresses] = useState<AddressesByKeyType>(null);

  useEffect(()=>{
    const fetchEndAddresses = async() => {
      const endLocationIds = Object.values(routes).reduce((acc: any, route: any) => {
        const endLocationId = route.end_location_id;
        const depotId = route.routebase_address_id;
        if((!isNull(endLocationId) && !isUndefined(endLocationId))) {
          acc.push(endLocationId);
        }
        if((!isNull(depotId) && !isUndefined(depotId))) {
          acc.push(depotId);
        }
        return acc;
      }, []);

      const filter = JSON.stringify({ filters: [{ name: 'id', op: 'in', val: endLocationIds }] });
    };
    if(routes){
      fetchEndAddresses();
    }
  
  }, [routes]);

  useEffect(() => {
    return () => { 
      setEndAddresses(null); 
    };
  }, []);
  
  return endAddresses;
};